import { WorkingLocation } from "@/types";
import { gql, TypedDocumentNode } from "@apollo/client";
import { EMPLOYMENT_FRAGMENT } from "./queries";

export const CREATE_EMPLOYMENT_MUTATION = gql`
  mutation CreateEmployment($input: BackofficeCreateEmploymentInput!) {
    createEmployment(input: $input) {
      success
      message
      employment {
        person {
          id
          employments {
            ...EmploymentFragment
          }
        }
      }
    }
  }
  ${EMPLOYMENT_FRAGMENT}
`;

type NoteInput = {
  content: string;
  priority: string;
  title?: string;
  visibility?: string;
  priorityExpirationDate?: string;
};

type CreateNonMemberEmploymentInput = {
  personId: string;
  facilityId: string;
  jobTitle: string;
  startedOn?: string | null;
  endedOn?: string | null;
  note?: NoteInput | null;
};

export const CREATE_NON_MEMBER_EMPLOYMENT_MUTATION: TypedDocumentNode<
  {
    createNonMemberEmployment: {
      success: boolean;
      message: string;
    };
  },
  { input: CreateNonMemberEmploymentInput }
> = gql`
  mutation CreateNonMemberEmployment($input: BackofficeCreateNonMemberEmploymentInput!) {
    createNonMemberEmployment(input: $input) {
      success
      message
    }
  }
`;

type UpdateNonMemberEmploymentInput = {
  id: string;
  facilityId: string;
  jobTitle: string;
  startedOn?: string | null;
  endedOn?: string | null;
  note?: NoteInput | null;
};

export const UPDATE_NON_MEMBER_EMPLOYMENT_MUTATION: TypedDocumentNode<
  {
    updateNonMemberEmployment: {
      success: boolean;
      message: string;
    };
  },
  { input: UpdateNonMemberEmploymentInput }
> = gql`
  mutation UpdateNonMemberEmployment($input: BackofficeUpdateNonMemberEmploymentInput!) {
    updateNonMemberEmployment(input: $input) {
      success
      message
    }
  }
`;

type UpdateEmploymentInput = {
  id: string;
  endedOn?: string | null;
  facilityId: string;
  isPrimary: boolean;
  jobClassification: string;
  jobTitle: string;
  startedOn: string;
  workingLocation: WorkingLocation;
  tourCode?: string | null;
  note?: NoteInput | null;
};

export const UPDATE_EMPLOYMENT_MUTATION: TypedDocumentNode<
  {
    updateEmployment: {
      success: boolean;
      message: string;
      employment?: {
        person: {
          id: string;
          employments: Array<{ id: string; isPrimary: boolean }>;
        };
      };
    };
  },
  { input: UpdateEmploymentInput }
> = gql`
  mutation UpdateEmployment($input: BackofficeUpdateEmploymentInput!) {
    updateEmployment(input: $input) {
      success
      message
      employment {
        person {
          id
          employments {
            id
            isPrimary
          }
        }
        ...EmploymentFragment
      }
    }
  }
  ${EMPLOYMENT_FRAGMENT}
`;

export const DELETE_EMPLOYMENT_MUTATION: TypedDocumentNode<
  {
    deleteEmployment: { success: boolean; message: string; employment: { person: { id: string; __typename: string } } };
  },
  { id: string }
> = gql`
  mutation DeleteEmployment($id: ID!) {
    deleteEmployment(id: $id) {
      success
      message
      employment {
        person {
          id
        }
      }
    }
  }
`;

export const UPSERT_RECRUITMENT_LEAD = gql`
  mutation UpsertRecruitmentLead($input: BackofficeUpsertRecruitmentLeadInput!) {
    upsertRecruitmentLead(input: $input) {
      message
      success
    }
  }
`;
